var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevP(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00568 4.99554L5.59868 0.40254C5.69026 0.309085 5.79947 0.234713 5.91997 0.183725C6.04048 0.132736 6.1699 0.106142 6.30075 0.105481C6.4316 0.104821 6.56128 0.130105 6.68229 0.179874C6.80331 0.229643 6.91326 0.302908 7.00578 0.395433C7.09831 0.487958 7.17157 0.597907 7.22134 0.718923C7.27111 0.839939 7.2964 0.96962 7.29574 1.10047C7.29507 1.23132 7.26848 1.36074 7.21749 1.48124C7.1665 1.60175 7.09213 1.71095 6.99868 1.80254L3.09868 5.70254L6.99868 9.60254C7.18124 9.78883 7.28291 10.0396 7.28159 10.3005C7.28028 10.5613 7.17608 10.8111 6.99164 10.9955C6.80721 11.1799 6.55744 11.2841 6.29661 11.2855C6.03578 11.2868 5.78497 11.1851 5.59868 11.0025L1.00568 6.41054C0.818206 6.22301 0.712891 5.9687 0.712891 5.70354C0.712891 5.43838 0.818206 5.18407 1.00568 4.99654V4.99554Z",
    fill: "#E1E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevP);
export default __webpack_public_path__ + "static/media/prevP.9fe6df233cd4dc26a56f47ede254b24b.svg";
export { ForwardRef as ReactComponent };